import {
  Badge,
  Box,
  Button,
  Dialog,
  HStack,
  Portal,
  Text,
  VStack,
} from "@chakra-ui/react";
import { formatUtcDatetimeToColombian } from "../../../../helpers/time";
import { Invoice } from "../../../../types/types";

const ACTIONS = {
  create: {
    label: "creado",
    colorPalette: "green",
  },
  update: {
    label: "editado",
    colorPalette: "blue",
  },
  cancel: {
    label: "archivado",
    colorPalette: "red",
  },
  erpSync: {
    label: "contabilizado",
    colorPalette: "purple",
  },
  enableCard: {
    label: "tarjeta activada",
    colorPalette: "teal",
  },
  disableCard: {
    label: "tarjeta desactivada",
    colorPalette: "gray",
  },
  enablePartialPayment: {
    label: "pago parcial activado",
    colorPalette: "teal",
  },
  disablePartialPayment: {
    label: "pago parcial desactivado",
    colorPalette: "gray",
  },
  enableCancelledPayment: {
    label: "pago habilitado",
    colorPalette: "teal",
  },
  disableCancelledPayment: {
    label: "pago deshabilitado",
    colorPalette: "gray",
  },
};

type Props = {
  open: boolean;
  onClose: () => void;
  editors?: Invoice["updatedBy"];
};

const EditorsModal = ({ open, onClose, editors }: Props): JSX.Element => {
  if (!editors) return <></>;

  return (
    <Dialog.Root
      open={open}
      onOpenChange={(e) => !e.open && onClose()}
      size="xl"
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header
              fontWeight={550}
              fontSize="1.25rem"
              textAlign="center"
              borderBottom="1px solid #ebecef80"
              p="1rem 1.5rem"
            >
              Editores
            </Dialog.Header>
            <Dialog.Body p="1.5rem">
              <VStack gap={4} align="stretch">
                {editors.map(
                  (e: { user: string; datetime: string; action: string }) => (
                    <Box key={e.datetime}>
                      <HStack justify="space-between" mb={2}>
                        <Text fontWeight={400} color="gray.600">
                          {e.user}
                        </Text>
                        <Badge
                          colorPalette={
                            ACTIONS[e.action as keyof typeof ACTIONS]
                              ?.colorPalette
                          }
                        >
                          {ACTIONS[e.action as keyof typeof ACTIONS]?.label}
                        </Badge>
                        <Text fontWeight={600} color="gray.600">
                          {formatUtcDatetimeToColombian(e.datetime)}
                        </Text>
                      </HStack>
                    </Box>
                  )
                )}
              </VStack>
            </Dialog.Body>
            <Dialog.Footer borderTop="1px solid #ebecef80">
              <Button onClick={onClose}>Cerrar</Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default EditorsModal;
